import { render, staticRenderFns } from "./DomainPercentA.vue?vue&type=template&id=aaa5fe2a&scoped=true&"
import script from "./DomainPercentA.vue?vue&type=script&lang=js&"
export * from "./DomainPercentA.vue?vue&type=script&lang=js&"
import style0 from "./DomainPercentA.vue?vue&type=style&index=0&id=aaa5fe2a&scoped=true&lang=scss&"
import style1 from "./DomainPercentA.vue?vue&type=style&index=1&id=aaa5fe2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa5fe2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
